import { Flex, Text } from '@chakra-ui/react'
import { FaStar } from 'react-icons/fa'

// Read-only rating summary shown on a card. Falls back to a plain line of text
// until somebody has actually rated the member.
const Stars = ({ averageScore, ratingCount, color = 'gold' }) => {
  if (!ratingCount) {
    return (
      <Text fontSize={12} opacity={0.5}>
        No ratings yet
      </Text>
    )
  }

  return (
    <Flex align="center" fontSize={13}>
      <FaStar color={`var(--chakra-colors-${color})`} />
      <Text fontWeight={700} ml={1}>
        {Number(averageScore).toFixed(1)}
      </Text>
      <Text ml={1} opacity={0.5}>
        ({ratingCount})
      </Text>
    </Flex>
  )
}

// Clickable 1-5 star input used inside the rating modal.
export const StarPicker = ({ value, onChange, isDisabled }) => (
  <Flex align="center" justify="center" mb={2}>
    {[1, 2, 3, 4, 5].map(score => (
      <Flex
        key={`star-${score}`}
        as="button"
        type="button"
        aria-label={`${score} star${score > 1 ? 's' : ''}`}
        disabled={isDisabled}
        onClick={() => onChange(score)}
        px={1}
        fontSize={28}
        cursor={isDisabled ? 'not-allowed' : 'pointer'}
        opacity={isDisabled ? 0.5 : 1}
        _hover={{ transform: isDisabled ? 'none' : 'scale(1.15)' }}
        transition="transform 0.1s"
      >
        <FaStar
          color={
            score <= value
              ? 'var(--chakra-colors-gold)'
              : 'var(--chakra-colors-light-gray)'
          }
        />
      </Flex>
    ))}
  </Flex>
)

export default Stars
